import React, { useRef, useEffect } from "react";

interface HtmlContentProps {
  content: string;
  className?: string;
}

const HtmlContent: React.FC<HtmlContentProps> = ({ content, className }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Create a temporary container to parse HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = content;

    // Remove dangerous elements
    const dangerousElements = tempDiv.querySelectorAll(
      "script, style, link, meta, frame, iframe, object, embed, form, input, button, textarea, select"
    );
    dangerousElements.forEach((el) => el.remove());

    // Sanitize links
    const links = tempDiv.querySelectorAll("a");
    links.forEach((link) => {
      const href = link.getAttribute("href");
      if (href && /^javascript:|vbscript:|data:/i.test(href)) {
        link.removeAttribute("href");
      }
      // Add security attributes to external links
      if (href && href.startsWith("http")) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      }
    });

    // Remove event handlers
    const allElements = tempDiv.getElementsByTagName("*");
    for (let i = 0; i < allElements.length; i++) {
      const el = allElements[i];
      const attributes = el.attributes;
      for (let j = attributes.length - 1; j >= 0; j--) {
        const attr = attributes[j];
        if (attr.name.startsWith("on")) {
          el.removeAttribute(attr.name);
        }
      }
    }

    // Clear and append sanitized content
    containerRef.current.innerHTML = "";
    containerRef.current.appendChild(tempDiv);
  }, [content]);

  return <div ref={containerRef} className={className} />;
};

export default HtmlContent;
